<template>
  <div :class="{ formArea: true, formFlex: !showSearch }">
    <div class="query-area" :style="{ height: searchHeight }" ref="searchBox">
      <el-form-item
        @submit.native.prevent
        v-for="(items, index) in searchList"
        :label="items.label"
        :key="index"
        label-width="'auto'"
      >
        <el-input
          v-if="items.type === 'input'"
          :style="{ width: items.itemwidth }"
          v-model="searchForm[items.key]"
          :placeholder="items.placeholder || '请输入关键字'"
          clearable
          @clear="seacrhMethod"
        ></el-input>
        <span v-if="items.type === 'datepick'">
          <el-date-picker
            :style="{ width: items.itemwidth }"
            v-model="searchForm[items.key]"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="clearTimeSet"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
          <span
            style="margin-left: 5px"
            v-if="items.btns && items.btns.length > 0"
          >
            <el-button
              v-for="btn in items.btns"
              :key="btn"
              type="text"
              @click="dayPick(items.key, btn)"
              :class="{
                btnSelect:
                  recentDate === btn ||
                  (items.deflut && deflutShow && btn === items.deflut),
                btnDeflut: true
              }"
              >{{ btn | handleBtnName }}</el-button>
          </span>
        </span>
        <dept-cascade
          :currentMenuId="currentMenuId"
          v-if="items.type === 'deptSel'"
          :deptKey="items.key"
          :defaultwhenNodata="items.defaultwhenNodata"
          @func="getDept"
        ></dept-cascade>
        <el-select
          v-if="items.type === 'select'"
          :disabled="items.disable"
          v-model="searchForm[items.key]"
          filterable
          clearable
          :style="{ width: items.itemwidth }"
          placeholder="全部"
        >
          <el-option
            v-for="item in items.data"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </div>
    <div class="submit-btn">
      <span v-if="btnShow" class="more-btn" @click="showAllSearch">
        <span>更多筛选</span>
        <i
          :class="
            showSearch
              ? 'el-icon-arrow-down icon-btn'
              : 'el-icon-arrow-up icon-btn'
          "
        ></i>
      </span>

      <el-button
        class="search-btn"
        type="primary"
        size="mini"
        @click="seacrhMethod"
        >查询</el-button>
    </div>
  </div>
</template>

<script>
import deptCascade from "@/components/core/deptCascade";
import { mapState } from "vuex";

export default {
  name: "SearchFrom",
  components: {
    deptCascade
  },
  data() {
    // const searchForm = {};
    // const searchList = Object.values(this.searchList);
    // console.log(searchList,'组件里面searchList')
    // searchList.forEach((item) => {
    //   searchForm[item.key] = item.value;
    // });
    return {
      // searchForm,
      searchForm: {},
      searchHeight: "38px",
      showSearch: true,
      deflutShow: true,
      btnShow: true,
      recentDate: 0
    };
  },
  computed: {
    ...mapState(["logInfo"])
  },
  props: ["searchList", "currentMenuId", "value"],
  model: {
    prop: "value",
    event: "returnBack"
  },
  methods: {
    reValue() {
      console.log(this.searchForm);
      this.$emit("returnBack", this.searchForm);
    },
    isBtnShow() {
      // console.log(this.$refs);
      const searchFormWidth = this.$refs.searchBox.clientWidth;
      let formTotalWith = 0;
      const formChild = this.$refs.searchBox.children;
      if (formChild && formChild.length > 0) {
        for (let i = 0; i < formChild.length; i += 1) {
          if (formChild[i].clientWidth) {
            formTotalWith += formChild[i].clientWidth;
          }
        }
        this.btnShow = formTotalWith > searchFormWidth;
      }
    },
    seacrhMethod() {
      this.$emit("seacrhMethod", this.searchForm);
    },
    showAllSearch() {
      if (this.showSearch) {
        this.searchHeight = "auto";
      } else {
        this.searchHeight = "38px";
      }
      this.showSearch = !this.showSearch;
      this.$emit("showAllSearch");
    },
    clearTimeSet() {
      // console.log(val);
      this.recentDate = 0;
      this.deflutShow = false;
      this.reValue();
    },
    dayPick(key, day) {
      this.deflutShow = false;
      this.recentDate = day;
      this.searchForm[key] = this.$getRangeStartEnd(day);
      this.reValue();
    },
    // 获取选中的部门
    getDept(data, key, fg) {
      // console.log(data, key);
      if (data && data.length) {
        this.searchForm[key] = data[data.length - 1];
      } else {
        if (fg) {
          // 无值时需要回显当前登录用户部门id
          this.searchForm[key] = this.logInfo.deptId;
        } else {
          // 无值时不需要回显当前登录用户部门id
          this.searchForm[key] = "";
        }
      }
    },
    initVal() {
      const searchForm = {};
      const searchList = Object.values(this.searchList);
      // console.log(searchList, "组件里面searchList");
      searchList.forEach(item => {
        searchForm[item.key] = item.value;
      });
      this.searchForm = searchForm;
    }
  },
  mounted() {
    this.isBtnShow();
    this.initVal();
  },
  filters: {
    handleBtnName(val) {
      let reVal = "";
      switch (val) {
        case 1:
          reVal = "当天";
          break;
        case 3:
          reVal = "近三天";
          break;
        case 7:
          reVal = "近一周";
          break;
        case 15:
          reVal = "近半个月";
          break;
        case 30:
          reVal = "近一个月";
          break;
        case 90:
          reVal = "近三个月";
          break;
        case 180:
          reVal = "近半年";
          break;
        case 365:
          reVal = "近一年";
          break;
        default:
      }
      return reVal;
    }
  },
  activated() {
    this.initVal();
  }
};
</script>

<style scoped>
.formFlex {
  position: fixed !important;
  z-index: 10;
  background: #ffffff;
  margin-right: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
}
.formArea {
  position: relative;
  /*text-align: left;*/
  text-align: right;
  padding: 0 20px;
}
.formArea .query-area {
  margin-right: 120px;
  overflow: hidden;
}
.formArea >>> .el-form-item__label {
  font-size: 12px;
}
.formArea .submit-btn {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 20;
}
.formArea .submit-btn .more-btn {
  cursor: pointer;
  padding: 0 12px;
}
.formArea .submit-btn .more-btn span {
  font-size: 12px;
  color: var(--btnSelectFontColor);
  padding-right: 4px;
}
.btnDeflut {
  padding: 6px;
  margin: 0;
  color: var(--btnSelectFontColor) !important;
}
.btnSelect {
  color: var(--btnSelectFontColor) !important;
  background: var(--btnSelectBgColor);
  border-color: var(--btnSelectBorderColor);
  padding: 6px;
}
</style>
